import TokenLogo from 'UIKit/TokenLogo'
import { Token } from 'config/types'

const CashRewardThumbnail: React.FC<{ token: Token; size?: number }> = ({ token, size = 24 }) => {
  return <TokenLogo token={token} size={size} style={{ display: 'flex', justifyContent: 'center' }} />
}

export default CashRewardThumbnail
